/**
 * footer control directive for displaying footer controls and information
 */
bookingApp.directive('skFooter',function($location){
    var types = ['full','cart-forwards','cart-back','cart-back-forwards','back','to-payment','to-lead-guest','to-pay-gate','skip-pay-gate','new-booking'];
    return {
        scope: {
            next: '=?',
            prev: '=?',
            main: '=?',
            show: '=?',
            mainContent: '=?',
            position: '=?',
            disabled: '=?'
        },
        transclude: true,
        template: '<footer class="sk-footer" ng-class="{\'sk-footer-fixed\': position === \'fixed\', \'sk-footer-absolute\': position === \'absolute\'}">'+
                        '<div class="sk-footer-controls-container">'+
                            '<button class="sk-footer-prev" ng-click="runPrev()" ng-show="show.prev" ng-class="{\'disabled\': disabled.prev}">'+
                                '<span class="glyphicon glyphicon-{{prevGlyph}}"></span>'+
                            '</button>'+
                            '<button class="sk-footer-main" ng-click="runMain()" ng-show="show.main" ng-class="{\'disabled\': disabled.main}">'+
                                '<div ng-bind-html="mainContent"></div>'+
                            '</button>'+
                            '<button class="sk-footer-next" ng-click="runNext()" ng-show="show.next" ng-class="{\'disabled\': disabled.next}">'+
                                '<span class="glyphicon glyphicon-{{nextGlyph}}"></span>'+
                            '</button>'+
                        '</div>'+
                    '</footer>',
        link: function(scope, element, attrs, controller){
            scope.show = scope.show ? scope.show : {prev: false, main: true, next: false};
				// may need a watcher for this.
				scope.prevGlyph = attrs.prevGlyph ? attrs.prevGlyph : 'chevron-left';
				scope.nextGlyph = attrs.nextGlyph ? attrs.nextGlyph : 'chevron-right';
            scope.$location = $location;
            scope.runNext = function(){
                if(!scope.disabled.next){
                    scope.next();
                }
            };
            scope.runPrev = function(){
                if(!scope.disabled.prev){
                    scope.prev();
                }
            };
            scope.runMain = function(){
                if(!scope.disabled.main){
                    scope.main();
                }
            };
            // setup back footer button event handler
            scope.goBack = function(){
                scope.session.loadingWarning.show = false;
                scope.session.loadingWarning.warning = null;
                window.history.back(-1);
                scope.safeApply();
            };
        }
    }
});
